const changeMigrationStatus = {
  data: {}
}

export default changeMigrationStatus;
